var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHungryPattern = function SvgHungryPattern(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 1268,
    viewBox: "0 0 547 1268",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377.612 2162C377.612 1726.63 -1.90309e-05 1726.62 -3.80617e-05 1291.25C-5.70925e-05 855.876 377.612 855.874 377.612 420.5C377.612 -14.8744 -9.51543e-05 -14.8756 -0.000114185 -450.25C-0.000133216 -885.625 377.612 -885.626 377.612 -1321L1265 -1321C1265 -885.626 887.388 -885.625 887.388 -450.25C887.388 -14.8756 1265 -14.8744 1265 420.5C1265 855.874 887.388 855.876 887.388 1291.25C887.388 1726.62 1265 1726.63 1265 2162L377.612 2162Z",
    fill: "#FFF7E5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHungryPattern, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HungryPattern.405ce10a.svg";
export { ForwardRef as ReactComponent };